export default {
  quizzes: [],
  pagination: {},
  quiz: {}
}
